var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_in"},[_c('header-view'),_c('nav-view'),_c('main',[_c('span',{staticClass:"sr-only",attrs:{"id":"ContentSkipLink","tabindex":"-1"}},[_vm._v("main content")]),_c('router-view')],1),_c('footer-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }